var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M15.5 10.5a5 5 0 1 0-10 0 5 5 0 0 0 10 0m-.966 5.097A6.499 6.499 0 0 1 4 10.5C4 6.91 6.91 4 10.5 4a6.499 6.499 0 0 1 5.097 10.534l4.184 4.185a.75.75 0 0 1-1.06 1.06z"
  })));
};
export default SvgSearch;